export const SINGLE_VIEW_MODE = 'single';
export const MULTI_VIEW_MODE = 'multi';
export const EGT = 'EGT';
export const FULLSCREEN_OPEN_TYPE = 'fullscreen';
export const INGAME_OPEN_TYPE = 'ingame';
export const MOBILE_MODE = 'mobile';
// fallow-ignore-next-line unused-export
export const DESKTOP_MODE = 'desktop';
export const LOBBY_SECTION_NAME = 'LOBBY';

export const LOBBY_INGAME_POPUP_TITLE_BAR_HEIGHT = '31px';

export const GET_PRIZE_TEXT_MONEY = 'MONEY';
export const GET_PRIZE_TEXT_GIFT_SPIN = 'GIFT_SPIN';
export const GET_PRIZE_TEXT_ITEM = 'ITEM';

export const OPEN_SECTION_PARAM = 'openSection';

export const CRASH_GAMES = ['XRide'];

// The lobby renders at most this many Top games; the ranking sprites under /top_games_numbers/ only go to 30
export const MAX_TOP_GAMES = 30;

// Snow effect feature toggle
export const SNOW_PERFORMANCE_MODE = true; // Set to true for better performance with fewer snowflakes

export const DEFAULT_LANGUAGE = 'EN';
export const AVAILABLE_LANGUAGES = {
  EN: 'English',
  BG: 'Български',
  DE: 'Deutsch',
  FR: 'Français',
  ES: 'Español',
  IT: 'Italiano',
  PT: 'Português',
  RU: 'Русский',
  TR: 'Türkçe',
  PL: 'Polski',
  CS: 'Čeština',
  SK: 'Slovenčina',
  HU: 'Magyar',
  RO: 'Română',
  HR: 'Hrvatski',
  SL: 'Slovenščina',
  SR: 'Српски',
  MK: 'Македонски',
  SQ: 'Shqip',
  EL: 'Ελληνικά',
  DA: 'Dansk',
  SV: 'Svenska',
  NL: 'Nederlands',
  ET: 'Eesti',
  LV: 'Latviešu',
  LT: 'Lietuvių',
  UK: 'Українська',
  KO: '한국어',
  'ZH-CN': '中文',
  KA: 'ქართული',
  'PT-BR': 'Português (Brasil)',
  'ES-CO': 'Español (Colombia)',
};

export const FILTER_ACTIVE_ICON = 'invert(48%) sepia(95%) saturate(627%) hue-rotate(65deg) brightness(126%) contrast(113%)';
export const LAST_PLAYED_STORAGE_KEY = 'lobby_last_played';

export const GAME_CARD_ASPECT_RATIO = 1.37804878; // (height / width)

export const GRID_GAP = {
  mobile: 8,
  desktop: 10 // min-width: 1025px
};
